const MENU_TITLE_INITIAL_STATE = {
  updateMenuTitleError: undefined,
  updateMenuTitleLoading: false,
  menuTitleForIgnoredDishType: undefined,
  menuTitleExpandedRowKeys: [],
  menuTitleHighlightedRowKey: undefined,
  menuTitleDishCountsError: undefined,
  menuTitleDishCountsLoading: false,
  menuTitleDishCounts: [],
}

export default MENU_TITLE_INITIAL_STATE
